import { Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@roc/ui';
import { observer } from 'mobx-react';
import { useStore } from '../../../hooks/useStore';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      marginTop: '20px'
    },
    button: {
      width: '160px',
      marginBottom:'50px'
    },
    margins: {
      marginTop: '20px'
    }
  };
});

export const MersOnboardingDocusignError = observer(({onFinish}) => {
  const {companyProfileStore} = useStore();
  const {loanFundingPreferenceStore} = companyProfileStore;
  const classes = useStyles();

  const handleFinish=()=>{
    onFinish();
  }
  return (
    <Grid container className={classes.container}>
      <Grid item >
        <ErrorIcon style={{ fontSize: '100px', color: '#a32929' }}/>
        <Typography variant="h2">
          Error completing the process
          <br/>
        </Typography>
      </Grid>
      <Grid item className={classes.margins}>
        <Typography>
          There was an error completing MERs onboarding process.
        </Typography>
        <Typography>
          Please try again.
        </Typography>
      </Grid>
      <Grid item className={classes.margins}>
        <Button
          testId='finish'
          variant='contained'
          color='primary'
          className={classes.button}
          onClick={handleFinish}
        >FINISH</Button>
      </Grid>
    </Grid>
  );
});
